export enum EEnvironment {
  UNDEFINED = 'undefined',
  PRODUCTION = 'production',
  STAGING = 'staging',
  MR = '',
  LOCAL = 'local',
  TESTING = 'testing',
}
